<template>
  <div>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true">
    </loading>
    <v-row class="text-left search-bar">
      <v-col class="pt-4 pl-0 col-12">
        <v-tabs class="tabsLeft" color="#002C61" align-with-title v-model="tab">
          <v-tabs-slider color="#002C61"></v-tabs-slider>
          <v-tab><span style="font-size:15pt; font-weight:550">詳細資料</span></v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <v-row class="ma-0" id="router" style="overflow-y:scroll" :style="viewStyle">
      <div id="box" class="pa-5 salary-box" style="margin-top:3%">
        <v-row class="pb-5">
          <v-icon class="ma-0 pa-0" size="30" style="color:#002C61">mdi-menu-right</v-icon>
          <h4 class="DarkBlue pt-1">薪資結構</h4>
        </v-row>
        <v-row class="mx-2" justify="center">
          <v-col class="px-2 py-0 col-12 col-md-5">
            <div class="ma-0">
              <div class="text-left pt-2 pt14">職別</div>
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined :value="positionTypeText"></v-text-field>
            </div>
            <div class="ma-0">
              <div class="text-left pt-2 pt14">姓名</div>
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.userName"></v-text-field>
            </div>
            <div class="ma-0">
              <div class="text-left pt-2 pt14">職級</div>
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.baseSalary"></v-text-field>
            </div>
          </v-col>
          <v-col class="px-2 py-0 col-12 col-md-5">
            <div class="ma-0">
              <div class="text-left pt-2 pt14">員工編號</div>
              <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.userId"></v-text-field>
            </div>
            <div class="ma-0">
              <div class="text-left pt-2 pt14">存款帳號</div>
              <v-row class="ma-0">
                <v-text-field class="text_field mr-2" dense readonly background-color="#F4F8F9" outlined v-model="datasets.bankCode"></v-text-field>
                <v-text-field class="text_field" dense readonly background-color="#F4F8F9" outlined v-model="datasets.bankAccount"></v-text-field>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
      
      <div id="box" class="pa-5">
        <v-row justify="center" style="width:100%">
          <div class="salary-container" style="width:80%">
            <div class="section">
              <div class="salary-titleB1">
                {{datasets.yearMonth}} 薪資明細
              </div>
            </div>
            <!-- 應發 -->
            <div class="section">
              <div class="salary-title">
                應發合計
                <span>{{ formatMoney(datasets.totalPayable) }}</span>
              </div>
              <div v-if="Number(datasets[item.key]) !== 0" class="salary-content" v-for="item in payableList" :key="item.key">
                <span>{{ item.label }}</span>
                <span>{{ formatMoney(datasets[item.key]) }}</span>
              </div>
            </div>
            <!-- 應扣 -->
            <div class="section pt-3">
              <div class="salary-title">
                應扣合計
                <span>{{ formatMoney(datasets.totalDeduction) }}</span>
              </div>
              <div v-if="Number(datasets[item.key]) !== 0" class="salary-content" v-for="item in deductionList" :key="item.key">
                <span>{{ item.label }}</span>
                <span>{{ formatMoney(datasets[item.key]) }}</span>
              </div>
            </div>
            
            <!-- 實發金額 -->
            <div class="section pt-3">
              <div class="salary-total">
                實發金額
                <span>{{ formatMoney(datasets.netPay) }}</span>
              </div>
            </div>
          </div>
        </v-row>
      </div>
    </v-row>
    <v-footer id="footer">
      <div class="text-center mx-auto footer">
        <v-btn class="btn" large outlined color="#002C61" @click="redirectPathPageInfo()">返回</v-btn>
      </div>
    </v-footer>
    <ShowMsg ref="ShowMsg" :onSave="onShowMsg"/>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.min.css';
import ShowMsg from '@/dialogs/ShowMsg'

export default {
  name: 'PayrollHistoryPage',
  components: {Loading,ShowMsg},
  mounted(){
    Promise.all([
      new Promise((resolve)=>{resolve(this.getDataset())}),
    ]).then(()=>{
      this.initDone = true
    })
  },
  data:() => ({
    isLoading: false,
    datasets: {},
    viewStyle: {},
    initDone: false,
    tab:0,
    payableList: [
      { key: 'monthlySalary', label: '底薪' },
      { key: 'researchAllowance', label: '研究費' },
      { key: 'supervisorAllowance', label: '主管加給' },
      { key: 'workAllowance', label: '工作補助' },
      { key: 'homeroomTeacherFee', label: '導師費' },
      { key: 'diligenceAllowance', label: '勤職津貼' },
      { key: 'dutyAllowance', label: '勤務津貼' },
      { key: 'overseasStudentAllowance', label: '僑生業務津貼' },
      { key: 'technicalSeniorityAllowance', label: '技術年資加給' },
      { key: 'promotionAdjustment', label: '晉級補差額' },
      { key: 'otherPayable', label: '其他應發' },
      { key: 'salaryAdjustment', label: '調薪補差額' },
      { key: 'departmentHeadAllowance', label: '群科主任津貼' },
      { key: 'campusSafetyAllowance', label: '校安津貼' },
      { key: 'taAllowance', label: '技佐津貼' },
      { key: 'monthlyHourlyFee', label: '鐘點費' },
      { key: 'yearEndBonus', label: '年終獎金' }
    ],
    deductionList: [
      { key: 'publicInsurance', label: '公保' },
      { key: 'laborInsurance', label: '勞保' },
      { key: 'healthInsurance', label: '健保' },
      { key: 'dutyFee', label: '值勤費' },
      { key: 'retirementSelfContributionTaxFree', label: '退休自提免稅' },
      { key: 'retirementAdditionalContributionTaxable', label: '增額自提應稅' },
      { key: 'gift', label: '賀禮' },
      { key: 'condolence', label: '奠儀' },
      { key: 'otherDeduction', label: '其他' },
      { key: 'supplementaryPremium', label: '補充保費' },
      { key: 'incomeTaxWithheld', label: '代扣所得稅' }
    ]
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{},
  computed: {
    positionTypeText() {
      const map = {
        '1': '專任',
        '2': '代理'
      }
      return map[this.datasets.positionType] || ''
    }
  },
  methods:{
    calculateWindows(){
      this.viewStyle = {height: window.innerHeight-199 + 'px'}
    },
    redirectPath(path){
      this.$router.push({path: path, query: {
        page: this.$route.query.page,
        userIdSel: this.$route.query.userIdSel,
        maintainBtn: this.$route.query.maintainBtn
      }})
    },
    redirectPathPageInfo(){
      this.$router.push(this.$route.query.pageInfo)
    },
    formatMoney(val) {
      if (val === null || val === undefined || val === '') return '0'
      return Number(val).toLocaleString()
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/pmAccountingMonthDetail/' + self.$route.query.id,
        params: {},
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為PHP-7001')
      }).finally(()=>{
      })
    },
    downloadPDF(){
      console.log('downloadPDF')
    },
    onShowMsg(){
      this.redirectPath('/payrollHistoryList')
    },
  }
}
</script>